import React, {Component} from "reactn";
import {Div, H1, H2, P, Button} from "glamorous";
import Dropdown from "react-dropdown";
import PreviewRead from "../Preview/Read";
import {track} from "../../../misc/utils";
import data from "../../../data";
import styles from "../../../styles";
import {post} from "../../../misc/api";
import {withFormik} from 'formik';
import Spinner from "../../common/LittleSpinner";
import ThanksMessage from "../ThanksMessage/ThanksMessage";

class PrintLabel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            city: null,
            cities: [],
            submitted: false
        };
    }

    render() {

        const {label} = this.props;

        return (
            <Div className="container container--generic">
                <Div css={styles.generic}>
                    <Div className="narrowPageContent">
                        <H1>{data.copy("printLabelHeading")}</H1>
                        <PreviewRead label={label}/>
                        <PrinterForm
                            cityList={this.global.locations||[]}
                            selectedLocation={this.global.selectedLocation}
                            label={label.renderedLabel}
                            productId={this.props.productId}
                            setArea={() => this.props.setArea('ProductSelector')}
                            submitted={this.state.submitted}
                            onSuccess={() => this.setState({submitted: true})}
                            onCancel={() => this.props.setArea('ProductSelector')}/>
                    </Div>
                </Div>
            </Div>
        );
    }
}

const SubmitToPrinterForm = props => {
    const {
        values,
        errors,
        isSubmitting,
        submitted,
        setArea,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        cityList,
        selectedLocation,
        label,
        onCancel
    } = props;

    values.image = label;
    values.selectedLocation = selectedLocation;

    if (isSubmitting) {
        return <Spinner/>
    }

    if(submitted) {
        return <ThanksMessage clicked={setArea} />
    }

    return (
        <form onSubmit={handleSubmit}>
            <Div marginTop="20px">
                <Dropdown
                    id="city"
                    placeholder="Select a city"
                    options={cityList||[]}
                    onChange={value => {
                        track.event('button', 'print_destination_updated', value.label);
                        setFieldValue('city', value.label);
                        setFieldValue('id', value.value);
                    }}
                    onBlur={() => setFieldTouched('city', true)}
                    value={values.city ? values.city : selectedLocation}
                />
                {!!errors.city && <div style={{color: 'red', marginTop: '.5rem'}}>{errors.city}</div>}
            </Div>

            <Div textAlign="center">
                <H2>{data.copy("printLabelSubHeading")}</H2>
                <P dangerouslySetInnerHTML={{__html: data.copy("printLabelCopy")}}/>
                <Button type="submit" css={styles.ctas.preview} disabled={isSubmitting}>
                    {data.copy("sendToPrinterBtn")}
                </Button>
                <Button type="button" onClick={onCancel} css={styles.ctas.outlineMaxWidth} disabled={isSubmitting}>
                    {data.copy("printLabelExitBtn")}
                </Button>
            </Div>
        </form>);
};

const PrinterForm = withFormik({
    validate: values => {
        let errors = {};
        if (!values.city && !values.selectedLocation.label) {
            errors.city = 'Required';
        }
        return errors;
    },
    handleSubmit: (values, {setSubmitting, props}) => {
        let locationId = values.id ? values.id : values.selectedLocation.value;
        let city = values.city ? values.city : values.selectedLocation.label;

        track.event('button', 'print_label', city);

        post('/print', {
            location: locationId,
            productId: values.productId,
            brandId: parseInt(process.env.REACT_APP_BRAND_ID, 10),
            image: values.image
        }).then(() => {
            setSubmitting(false);
            props.onSuccess();
        }).catch((err) => {
            console.log(err);
            setSubmitting(false);
            alert("Error uploading your image. Please try again in a few moments");
        });
    }
})(SubmitToPrinterForm);

export default PrintLabel;



// WEBPACK FOOTER //
// ./src/components/areas/PrintLabel/index.js